module.exports = __webpack_public_path__ + "static/img/Dear.461db2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dear.jpg
// module id = SIOs
// module chunks = 0